<template>
    <BaseEditPage
        :context="context"
        :alvqa="alvqa"
        cancelIconRoute="/az/azgroups"
    >
<!-- HEADLINE -->
        <template v-slot:headline="{ data }">
            <div class="d-flex align-center" style="margin-top: 8px;">
                <!-- NEW A-Z Group -->
                <div v-if="$route.params.alvId === 'new'" class="headline" :alvqa="alvqa + '-title'">
                    {{ $t('lang_GENERAL_CAPTION_EDIT_PAGE_UNTITLED') }}
                </div>  

                <!-- existing A-Z Group TODO_PT: Name of Group not showing -->
                <div v-if="data != null" class="headline" :alvqa="alvqa + '-title'">
                    {{ (data.group !== null && data.group !== '') ? data.group : data.gemaName }}
                </div>

                <div class="ml-2" style="width: 24px; height: 24px; display: flex; align-items: center; justify-content: center;">
                    <ContextHelpIcon 
                        v-if="hasContextHelp"
                        context="AzGroupsEdit"
                        :alvqa="alvqa + '-context-help-icon'"
                    />
                </div>
            </div>
        </template>

        <!-- EDIT FORM -->
        <template v-slot:editForm="{ data }">
            <!-- 1st column -->
            <v-col cols="1">
                <v-row>
                    <v-col v-if="data != null">
                        <v-img 
                            v-if="data.pictureBig !== null"
                            :src="data.pictureBig"
                        ></v-img>
                        <v-img
                            v-else
                            aspect-ratio="1"
                            class="defaultImageEditPage"
                            :alvqa="alvqa + '-image'"
                        >
                            <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                            >
                                <!-- <BaseIcon 
                                    @click="uploadPicture()"
                                    icon="cloud_upload"
                                    tooltipText="lang_GENERAL_CAPTION_UPLOAD_IMAGE"
                                />   -->
                            </v-row>
                        </v-img>
                    </v-col>
                </v-row>
            </v-col> 

            <!-- 2nd column -->
            <v-col cols="3">
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Group"
                        :label="$t('lang_AZ_GROUPS_CAPTION_GROUP_NAME')" 
                        rules="required"
                        :alvqa="alvqa + '-textfield-group-name'"
                    />
                </v-row>
                <v-row v-if="isJapaneseUi">
                    <BaseEditPageTextField 
                        :context="context"
                        field="NameKatakana"
                        :label="$t('lang_AZ_GROUPS_CAPTION_NAME_KATAKANA')"
                        :alvqa="alvqa + '-textfield-name-katakana'"
                    />
                </v-row>
                <v-row class="align-center">
                    <BaseEditPageGoogleAddressAutocomplete 
                        :context="context"
                        field="AddressRowOne"
                        :withMargin="false"
                        :label="$t('lang_AZ_PERSONS_CAPTION_ADDRESS_ROW_1')"
                        :alvqa="alvqa + '-textfield-address-row-one'"
                        class="ml-4"
                        style="flex: 1;"
                    />
                    <BaseIcon
                        icon="place"
                        :alvqa="alvqa + '-icon-google-places'"
                        color="iconStandard"
                        small
                        class="mr-4"
                        :tooltipText="$t('lang_AZ_PERSONS_CAPTION_GOOGLE_PLACES_AUTOCOMPLETE')"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="AddressRowTwo"
                        :label="$t('lang_AZ_PERSONS_CAPTION_ADDRESS_ROW_2')"
                        :alvqa="alvqa + '-textfield-address-row-two'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Zip"
                        :label="$t('lang_AZ_PERSONS_CAPTION_ZIP')"
                        :alvqa="alvqa + '-textfield-zip'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="City"
                        :label="$t('lang_AZ_PERSONS_CAPTION_CITY')"
                        :alvqa="alvqa + '-textfield-city'"
                    />
                </v-row> 
                <v-row>
                    <BaseEditPageTextField 
                        :context="context" 
                        field="State" 
                        :label="$t('lang_AZ_PERSONS_CAPTION_STATE')" 
                        :alvqa="alvqa + '-textfield-state'" />
                </v-row> 
                <v-row>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="Country"
                        :items="countries" 
                        :resetValNull="true"
                        :label="$t('lang_AZ_PERSONS_CAPTION_COUNTRY')"  
                        :alvqa="alvqa + '-dropdown-country'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextarea 
                        :context="context" 
                        field="FullShippingAddress"
                        rows="5"
                        :label="$t('lang_AZ_GROUPS_CAPTION_SHIPPING_ADDRESS')" 
                        :alvqa="alvqa + '-textarea-full-shipping-address'"
                    />
                </v-row>
            </v-col>  

            <!-- 3rd column -->
            <v-col cols="3">
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="AlvId"
                        :label="$t('lang_GENERIC_CAPTION_ALVID')"
                        :clearable="false"
                        :disabled="true"
                        :alvqa="alvqa + '-textfield-alvid'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Web"
                        :label="$t('lang_AZ_PERSONS_CAPTION_WEB')"
                        :alvqa="alvqa + '-textfield-web'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Facebook"
                        :label="$t('lang_AZ_PERSONS_CAPTION_FACEBOOK')"
                        :alvqa="alvqa + '-textfield-facebook'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Twitter"
                        :label="$t('lang_AZ_PERSONS_CAPTION_TWITTER')"
                        :alvqa="alvqa + '-textfield-twitter'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Youtube"
                        :label="$t('lang_AZ_PERSONS_CAPTION_YOUTUBE')"
                        :alvqa="alvqa + '-textfield-youtube'"
                    />
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <div class="input-label" style="display: flex; align-items: center; margin-bottom: 4px;">
                        <span>{{ $t('lang_AZ_PERSONS_CAPTION_TAGS') }}</span>
                        <HelpIcon
                            :urls="{
                                de: '41060331',
                                en: '192282755',
                                ko: '176881668',
                            }"
                            :tooltipText="$t('lang_GENERIC_CLICK_TO_HELP_CENTER')"
                        />
                        </div>
                        <BaseEditPageTextField 
                            :context="context"
                            field="Tags"
                            :withMargin="false"
                            class="pt-0 mt-0"
                            :alvqa="alvqa + '-textfield-tags'"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <!-- inv_lief_notice = Versandnotiz -->
                    <!-- inv_bemerkungen = Bemerkungen -->
                    <BaseEditPageTextarea 
                        :context="context"
                        field="ShippingNote"
                        rows="5"
                        :label="$t('lang_AZ_GROUPS_CAPTION_SHIPPING_NOTE')"
                        :alvqa="alvqa + '-textarea-shipping-note'"
                    />
                </v-row>
            </v-col>    

            <!-- 4th column  -->
            <v-col cols="3">
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Phone"
                        :label="$t('lang_AZ_PERSONS_CAPTION_PHONE')"
                        :alvqa="alvqa + '-textfield-phone'"
                    />
                </v-row>   
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Fax"
                        :label="$t('lang_AZ_PERSONS_CAPTION_FAX')"
                        :alvqa="alvqa + '-textfield-fax'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Cellphone"
                        :label="$t('lang_AZ_PERSONS_CAPTION_CELLPHONE')"
                        :alvqa="alvqa + '-textfield-cellphone'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Email"
                        :label="$t('lang_AZ_PERSONS_CAPTION_EMAIL')"
                        :alvqa="alvqa + '-textfield-email'"
                    />
                </v-row>  
                <v-row>
                    <BaseEditPageDropdown 
                        :context="context" 
                        field="FormatNameAddress" 
                        :items="dropdownFormatNameAddress"
                        :clearable="false" :label="$t('lang_AZ_PERSONS_CAPTION_FORMAT_NAME_ADDRESS')"
                        :alvqa="alvqa + '-dropdown-format-name-address'" 
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextarea 
                        :context="context" 
                        field="Notes"
                        rows="7"
                        :label="$t('lang_GENERIC_CAPTION_NOTES')" 
                        :alvqa="alvqa + '-textarea-notes'"
                    />
                </v-row>
            </v-col> 



            <!-- 5th column -->
            <v-col cols="2">
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="GemaName"
                        :label="$t('lang_GENERIC_AZ_CAPTION_GEMA_NAME')"  
                        :clearable="false"
                        :readonly="false"
                        :alvqa="alvqa + '-textfield-gema-name'"
                    />
                </v-row>     
                <v-row>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="Type"
                        :items="azTypes" 
                        :label="$t('lang_AZ_PERSONS_CAPTION_TYPE')"
                        :multiple="true"
                        :selection="true"
                        :alvqa="alvqa + '-dropdown-type'"
                    />
                </v-row>  
                <v-row>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="Visibility"
                        :items="visibilityItems" 
                        :label="$t('lang_AZ_PERSONS_CAPTION_VISIBILITY')"
                        :clearable=false
                        :alvqa="alvqa + '-dropdown-visibility'" 
                    />
                </v-row>  
            </v-col>
        </template>

<!-- PANELS -->
        <template v-slot:panels>
            <!-- Persons -->
            <DeletionDialog :useContextSetinVuex="true"/>
            <ContextHelpDialog />
            <PersonsEditPanel />
            <PersonsEditPanelDialog />

            <!-- Metadata -->
            <MetadataPanel />

            <!-- Mappings -->
            <AzGroupsMappingsPanel />

            <!-- Finance -->
            <FinancePanel />

            <!-- Other IDs-->
            <OtherIdsPanel/>
            <OtherIdsEditDialog/>
        </template>
    </BaseEditPage>
</template>

<script>
import BaseEditPage from '@/components/_base/BaseEditPage'

import BaseIcon from '@/components/_buttons/BaseIcon'
import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'
import BaseEditPageGoogleAddressAutocomplete from '@/components/_editForm/BaseEditPageGoogleAddressAutocomplete'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'
import BaseEditPageTextarea from '@/components/_editForm/BaseEditPageTextarea'
import { DropdownFormatNameAdressTypes } from '@/assets/dropdowns/alvDropdowns.js'

import MetadataPanel from './_panels/MetadataPanel'
import AzGroupsMappingsPanel from './_panels/MappingsPanel'
import FinancePanel from './_panels/FinancePanel'
import PersonsEditPanel from '@/components/_panels/PersonsEditPanel'
import OtherIdsPanel from './_panels/OtherIdsPanel'
import OtherIdsEditDialog from './_dialogs/OtherIdsEditDialog'

import DeletionDialog from '@/components/_dialogs/DeletionDialog'
import PersonsEditPanelDialog from '@/components/_dialogs/PersonsEditPanelDialog'
import HelpIcon from '@/components/_buttons/HelpIcon'
import ContextHelpIcon from '@/components/_buttons/ContextHelpIcon'
import ContextHelpDialog from '@/components/_dialogs/ContextHelpDialog'

export default {
    name: "AzGroupsEdit",
    components: {
        BaseEditPage,
        BaseIcon,
        HelpIcon,
        ContextHelpIcon,
        ContextHelpDialog,
        BaseEditPageTextField,
        BaseEditPageGoogleAddressAutocomplete,
        BaseEditPageDropdown,
        BaseEditPageTextarea,

        MetadataPanel,
        AzGroupsMappingsPanel,
        FinancePanel,
        PersonsEditPanel,
        OtherIdsPanel,
        OtherIdsEditDialog,

        DeletionDialog,
        PersonsEditPanelDialog

    },
    data() {
        return {
            context: "AzGroups",
            alvqa: "az-groups-edit-form",
            hasContextHelp: false
        }
    },
    async created() {
        this.hasContextHelp = await this.$alvPlugin.checkContextHelpAvailability('AzGroupsEdit')
    },
    computed: {
        azGroupsData() { return this.$store.getters.getAzGroupsDetails }, 
        isJapaneseUi() { return ['ja', 'jp'].includes(this.$i18n.locale) },

        // Dropdowns
        countries() { 
            return this.$alvPlugin.getListOfTranslatedCountries()
        },
        azTypes() { 
            let typesArr
            let azTypes = this.$store.getters['getAzTypes' + this.$i18n.locale.toUpperCase()] 
            if(azTypes === undefined) azTypes = this.$store.getters.getAzTypesEN // fallback EN

            if(azTypes !== undefined) {
                typesArr = JSON.parse(JSON.stringify(azTypes))
                typesArr.forEach(element => {
                    element['alvqa'] = this.alvqa + '-dropdown-type-' + element.value.toLowerCase()
                });                
            } else {
                typesArr = []
            }
            typesArr.sort(function(a, b) {
                let textA = a.text.toUpperCase();
                let textB = b.text.toUpperCase();
                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
            });
            return typesArr

        },
        visibilityItems() { 
            let visibilityArr
            let visibility = this.$store.getters['getVisibility' + this.$i18n.locale.toUpperCase()] 
            if(visibility === undefined) visibility = this.$store.getters.getVisibilityEN // fallback EN

            if(visibility !== undefined) {
                visibilityArr = JSON.parse(JSON.stringify(visibility))
                visibilityArr.forEach(element => {
                    element['alvqa'] = this.alvqa + '-dropdown-visibility-' + element.value
                });
            } else {
                visibilityArr = []
            }

            return visibilityArr
        },
        dropdownFormatNameAddress() {
            return DropdownFormatNameAdressTypes
        },     
    },
    methods: {
        uploadPicture() {
            console.log('Upload Pic')
        },
    },
    mounted() {
        this.$store.commit('setCountries')
        this.$store.commit('setVisibility')
        this.$store.commit('setDealflow')
        this.$store.commit('setAzTypes')
    },
}
</script>